import { render, staticRenderFns } from "./LoayltyPayment.vue?vue&type=template&id=fcd98ed8&scoped=true&"
import script from "./LoayltyPayment.vue?vue&type=script&lang=js&"
export * from "./LoayltyPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcd98ed8",
  null
  
)

export default component.exports